import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import "../styles/components/PatientEmergencyContact.scss";
import LeydenSelect from "./LeydenSelect";
import { EmergencyContactSchema } from "../schemas/Patient.schema";
import { RELATION_OPTIONS, RELATION_OPTIONS_MINOR } from "../constants/options";
import TextInput from "./TextInput";
import { Button } from "react-bootstrap";
import Utility from "../utility/Utility";
import { Trans } from "react-i18next";
import ErrorBoundaryHandler from "./ErrorBoundaryHandler";

const PatientEmergencyContact = (props: any) => {
  const [validateOnChangeFlag, setvalidateOnChangeFlag] = useState(false);
  const isBeneficiaryMinor = Utility.isMinor(props?.dob);

  const handlePreviousClick = () => {
    Object.entries(formik.values).map(val => {
      sessionStorage.setItem(val[0], val[1]);
    });
    props.onPreviousClick(formik.values);
  };

  const handleSelectContact = (option: any) => {
    formik.setFieldValue("relationship", option.value);
    props.dropDownClick(option.value);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const formik = useFormik({
    initialValues: {
      relationship: (isBeneficiaryMinor && props.defaultValues?.relationship === "self") ? "" : props.defaultValues?.relationship || "",
      name: (isBeneficiaryMinor && props.defaultValues?.relationship === "self") ? "" : props.defaultValues?.name || "",
      contactNumber: (isBeneficiaryMinor && props.defaultValues?.relationship === "self") ? "" : props.defaultValues?.contactNumber || "",
    },
    validateOnChange: validateOnChangeFlag,
    validationSchema: EmergencyContactSchema,
    onSubmit: values => {
      Object.entries(values).map(val => {
        sessionStorage.setItem(val[0], val[1]);
      });
      props.onEmergencyContactDetails(values);
    },
  });

  const emergencyContactEditable = formik.values.relationship === "self";

  return (
    <form
      className="p-0 patientEmergencyContact"
      onSubmit={e => {
        e.preventDefault();
        setvalidateOnChangeFlag(true);
        formik.handleSubmit(e);
      }}
      onChange={(e: any) => {
        formik.setFieldValue(e.target["id"], e.target.value);
      }}
    >
      <div className="bg-light-gray">
        <h5 className="bg-light-blue p-2 ps-3  heading">
          <Trans i18nKey={"emergency_contact_details"}></Trans>
        </h5>
        <div className="p-3 form-width">
          <div>
            <LeydenSelect
              label={"Select Relationship"}
              label_key="select_relation"
              options={Utility.getOptions(
                isBeneficiaryMinor ? RELATION_OPTIONS_MINOR : RELATION_OPTIONS
              )}
              onChange={handleSelectContact}
              id={"relationship"}
              defaultSelected={formik.values.relationship}
              error={formik.errors.relationship}
              mandate={true}
              blankOptionLabel={Utility.getTranslatedBlankOption(
                "select_relation"
              )}
            />
          </div>

          <div className="mt-4">
            <TextInput
              label="Name"
              label_key="relative_name"
              type="text"
              id="name"
              maxLength={50}
              error={formik.errors.name}
              value={formik.values.name}
              defaultValue={formik.values.name}
              onChange={formik.handleChange}
              mandate={true}
              disabled={!emergencyContactEditable}
            />
          </div>
          <div className="mt-4">
            <TextInput
              label="Contact Number"
              label_key="contact_number"
              type="number"
              id="contactNumber"
              defaultValue={formik.values.contactNumber}
              mandate={true}
              maxLength={10}
              error={formik.errors.contactNumber}
              disabled={!emergencyContactEditable}
              onChange={formik.handleChange}
            />
          </div>
        </div>
      </div>
      <div className="text-lg-start text-md-end text-end mt-4">
        <Button
          className="btn-outline addPatientBtn"
          type="button"
          onClick={handlePreviousClick}
        >
          <Trans i18nKey={"back"}></Trans>
        </Button>
        <Button
          className="ms-4 addPatientBtn"
          data-testid="contactDetailsSubmitBtn"
          type="submit"
        >
          <Trans i18nKey={"next"}></Trans>
        </Button>
      </div>
    </form>
  );
};

export default ErrorBoundaryHandler(PatientEmergencyContact);
